/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SearchDoctorBasicInfoResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'DoctorBasicInfoResponseData',
      },
    },
  }],
} as const;
